<template>
  <div class="mx-auto w-11/12 sm:w-9/12 sm:min-w-150 mt-2 sm:mt-12 max-w-4xl">
    <div
      class="mx-auto my-10 ml-10 sm:flex justify-between max-w-2xl"
    >
      <img
        src="@/assets/people.svg"
      >
      <div
        class="text-4xl font-bold mx-10"
      >
        ¿A quiénes vas a cuidar?
      </div>
    </div>
    <div
      class="mx-auto text-center"
    >
      <div
        class="text-2xl font-bold mt-2"
      >
        <span class="text-purple-500">Descarga</span> el formato
      </div>
      <a
        class="block bg-blue-500 text-white text-center text-2xl rounded-md py-2 my-2 w-1/3 mx-auto external"
        href="https://firebasestorage.googleapis.com/v0/b/cuidarte-app.appspot.com/o/templates%2FCuidarte%20Formato%20Excel.xlsx?alt=media&token=351dc102-0b56-4f10-beba-e9752c261e4c"
        target="_blank"
      >
        Descargar formato
      </a>
    </div>
    <div
      class="text-lg mx-5 sm:mx-auto text-center"
    >
      <div>
        Llénalo con la información de las personas a las que cuidarás y súbelo
      </div>
      <label>
        <div
          ref="dropArea"
          :class="`h-40 mt-10 border border-dashed text-gray-400 border-gray-400 cursor-pointer ${getHighlightClass}`"
        >
          <eva-icon
            class="mt-6"
            name="upload-outline"
            fill="#cbd5e0"
            width="64"
            height="64"
          />
          <div>
            Cargar formato
          </div>
          <input
            type="file"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            class="absolute left-0 w-5/12 invisible pointer-events-none"
            @change="handleFile($event)"
          >
        </div>
      </label>
      <div v-if="fileParsed">
        <div v-if="Object.keys(fileErrors).length > 0">
          <table class="mt-6 w-full shadow-lg">
            <thead>
              <tr class="text-center bg-gray-500 text-white font-bold">
                <td class="p-2">
                  Fila #
                </td>
                <td class="p-2">
                  Errores
                </td>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(errorRow, errorKey) in fileErrors"
                :key="errorKey"
                :class="`${(errorKey % 2) ? 'bg-gray-200' : ''}`"
              >
                <td>{{ Number(errorKey) + 2 }}</td>
                <td
                  class="text-left"
                >
                  <span
                    v-for="(errors, index) in errorRow"
                    :key="index"
                    class="inline-block p-2 my-1 rounded-lg bg-red-200 border-2 border-red-500"
                  >
                    {{ ParseErrors(errors) }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          v-else
          class="mt-10 text-left"
        >
          Previsualización
          <div class="w-full overflow-x-scroll">
            <person-table
              class="my-5 max-h-lg"
              :persons="parsedPersons"
              :summarize="true"
              :readOnly="true"
            />
          </div>
          <div
            class="cursor-pointer bg-blue-500 text-white w-64 text-2xl px-2 py-1 rounded-md my-2 mt-12 mx-auto h-16 leading-14"
          >
            <div
              class="text-center w-full"
              @click="upload"
            >
              Confirmar
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as axios from 'axios'
import { mapState } from 'vuex'
import PersonTable from '@/components/personTable'

export default {
  components: {
    PersonTable,
  },
  props: {
    showOptions: { type: Boolean, default: false },
  },
  data () {
    return {
      persons: [],
      fileParsed: false,
      fileErrors: {},
      cleanAfterUpdate: false,
      dropArea: null,
      highlight: false,
    }
  },
  computed: {
    getHighlightClass () {
      if (this.highlight) {
        return 'bg-purple-500 text-white'
      }
      return ''
    },
    parsedPersons () {
      const persons = []
      for (const person of this.persons) {
        persons.push({
          name: person.name,
          email: person.email,
          phoneNumber: person.phoneNumber,
          nationalPhoneNumber: person.phoneDetails.nationalPhone,
          dialCode: person.phoneDetails.country.dialCode,
          documentID: person.documentID,
          registered: person.registered,
          rejected: person.rejected,
          tags: person.tags,
          hideIndexInput: true,
        })
      }
      return persons
    },
    ...mapState({
      instanceID: state => state.admin.instanceID,
      uid: state => state.auth.uid,
    }),
  },
  watch: {
  },
  async mounted () {
    this.dropArea = this.$refs.dropArea
    const actions = ['dragenter', 'dragover', 'dragleave', 'drop']
    actions.forEach(eventName => {
      this.dropArea.addEventListener(eventName, this.preventDefaults, false)
    })
    const highlightActions = ['dragenter', 'dragover']
    highlightActions.forEach(eventName => {
      this.dropArea.addEventListener(eventName, this.highlightDragArea, false)
    })

    const unhighlightActions = ['dragleave', 'drop']
    unhighlightActions.forEach(eventName => {
      this.dropArea.addEventListener(eventName, this.unhighlightDragArea, false)
    })
    this.dropArea.addEventListener('drop', this.handleFile, false)
  },
  methods: {
    highlightDragArea (e) {
      this.highlight = true
    },
    unhighlightDragArea (e) {
      this.highlight = false
    },
    preventDefaults (e) {
      e.preventDefault()
      e.stopPropagation()
    },
    handleInput () {
      if (!this.cleanAfterUpdate) {
        this.$f7.dialog.confirm('Si activas esto, la información que subas <span class="text-purple-500 font-bold">reemplazará por completo</span> a la base de datos actual. ¿Deseas continuar?', '¿Seguro?', () => {
          this.cleanAfterUpdate = true
        })
      } else {
        this.cleanAfterUpdate = false
      }
    },
    getBackground () {
      if (!this.cleanAfterUpdate) {
        return 'bg-purple-200'
      }
      return 'bg-purple-500'
    },
    ParseErrors (error) {
      switch (error) {
        case 'missing-phoneNumber':
          return 'El numero de celular y código de pais son obligatorios.'
        case 'missing-name':
          return 'El nombre es obligatorio'
        case 'data-page':
          return 'El archivo no concuerda con el formato descargado.'
        case 'duplicated-document':
          return 'Documento de identidad duplicado.'
        default:
          return 'Error indefinido'
      }
    },
    handleFile (e) {
      this.fileParsed = false
      this.fileErrors = {}
      const files = e.target.files || (e.dataTransfer && e.dataTransfer.files)
      this.doFile(files)
      e.target.value = null
    },
    doFile (files) {
      var rABS = typeof FileReader !== 'undefined' && (FileReader.prototype || {}).readAsBinaryString
      // var domrabs = document.getElementsByName('userabs')[0]
      this.canWorker = typeof Worker !== 'undefined'
      if (!this.canWorker) return
      // var domwork = document.getElementsByName('useworker')[0]
      var xw = (data) => {
        var worker = new Worker(`${process.env.BASE_URL}xlsxworker.js`)
        worker.onmessage = (e) => {
          switch (e.data.t) {
            case 'ready': console.info('worker-ready'); break
            case 'error': console.error(JSON.parse(e.data.d)); break
            case 'validationError': this.handleValidationErrors(JSON.parse(e.data.d)); break
            case 'xlsx': this.processData(JSON.parse(e.data.d)); break
          }
        }
        worker.postMessage({ d: data, b: rABS ? 'binary' : 'array' })
      }

      var f = files[0]
      var reader = new FileReader()
      reader.onload = (e) => {
        var data = e.target.result
        if (!rABS) data = new Uint8Array(data)
        xw(data)
      }
      if (rABS) reader.readAsBinaryString(f)
      else reader.readAsArrayBuffer(f)
    },
    async processData (data) {
      this.persons = data
      this.fileParsed = true
    },
    async upload () {
      try {
        this.$f7.dialog.preloader('Procesando datos...')
        const data = {
          instanceID: this.instanceID,
          persons: this.persons,
          cleanAfterUpdate: this.cleanAfterUpdate,
          userID: this.uid,
        }
        console.info(data)
        const response = await axios({
          url: '/users/batch',
          method: 'POST',
          data,
        })
        this.$emit('batchSuccess')
        console.info(response)
        this.$f7.dialog.close()
      } catch (err) {
        this.$f7.dialog.close()
        console.error(err)
      }
    },
    handleValidationErrors (errors) {
      this.fileParsed = true
      for (const errorKey of Object.keys(errors)) {
        this.$set(this.fileErrors, errorKey, errors[errorKey])
      }
    },
  },
}
</script>
